// React Router strips the basename (/servicePortal), so pathname values here
// look like '/serviceCatalog/42'. All modules are ssp_-prefixed so the
// Self-Service Portal is unambiguous in Mixpanel.
export const ANALYTICS_MODULE = {
  SERVICE_CATALOG: 'ssp_service_catalog',
  SR_VIEW: 'ssp_sr_view',
  SUBMIT_REQUEST: 'ssp_submit_request',
  SEARCH: 'ssp_search',
  SCOREBOARD: 'ssp_scoreboard',
  MY_SETTINGS: 'ssp_my_settings',
  HOME: 'ssp_home',
  UNKNOWN: 'ssp_unknown'
};

// Most-specific prefixes first; matched by string prefix.
const PATH_TO_MODULE = [
  ['/serviceCatalog', ANALYTICS_MODULE.SERVICE_CATALOG],
  ['/SRview', ANALYTICS_MODULE.SR_VIEW],
  ['/submitSR', ANALYTICS_MODULE.SUBMIT_REQUEST],
  ['/submitIncident', ANALYTICS_MODULE.SUBMIT_REQUEST],
  ['/ActionEdit', ANALYTICS_MODULE.SUBMIT_REQUEST],
  ['/search', ANALYTICS_MODULE.SEARCH],
  ['/scoreboard', ANALYTICS_MODULE.SCOREBOARD],
  ['/mySettings', ANALYTICS_MODULE.MY_SETTINGS],
  ['/home', ANALYTICS_MODULE.HOME]
];

export function getModuleFromPath(pathname) {
  if (!pathname) {
    return ANALYTICS_MODULE.UNKNOWN;
  }
  if (pathname === '/') {
    return ANALYTICS_MODULE.HOME;
  }
  for (let i = 0; i < PATH_TO_MODULE.length; i++) {
    const prefix = PATH_TO_MODULE[i][0];
    const moduleName = PATH_TO_MODULE[i][1];
    if (pathname.indexOf(prefix) === 0) {
      return moduleName;
    }
  }
  return ANALYTICS_MODULE.UNKNOWN;
}

// Derives the Mixpanel `page` name from a pathname: the first path segment
// (so entity ids in later segments never leak into the page property), or
// 'home' for the root. Shared by App (initial view) and AnalyticsWrapper
// (route changes) so the same route always reports the same page.
export function getPageFromPath(pathname) {
  if (!pathname) {
    return 'home';
  }
  const segments = pathname.split('/').filter(Boolean);
  return segments.length ? segments[0] : 'home';
}



// WEBPACK FOOTER //
// ./utils/getModuleFromPath.js